export default __webpack_public_path__ + "static/media/e-nstitute-small.752545a3.png";